import React from "react";
import Selector from "./Selector";
import { formatFacilityOptions } from "./helpers";

const FacilitySelector = ({ facilities, value, setParentState }) => {
  const handleUpdateFacilityValue = (val) => {
    const facilityId = value;
    if (val == null) {
      setParentState({
        facilityId: null,
        clientId: null,
        medId: null,
        medications: [],
        clients: [],
      });
    } else if (facilityId && val.value != facilityId.value) {
      setParentState({
        facilityId: val,
        clientId: null,
        medId: null,
        clients: [],
        medications: [],
      });
    } else {
      setParentState({
        facilityId: val,
        clients: [],
        medications: [],
      });
    }
    fetchClients(val.value);
  };

  const fetchClients = async (facilityId) => {
    setParentState({ clientsIsLoading: true });
    $.ajax({
      url: `/api/staff/v1/groups/${facilityId}/clients_for_medication_log.json`,
      method: "GET",
      success: (data) => {
        setParentState({ clientsIsLoading: false });
        setParentState({
          clients: data,
        });
      },
    });
  };

  return (
    <Selector
      value={value}
      placeholder="Facility..."
      onUpdateValue={(value) => handleUpdateFacilityValue(value)}
      options={formatFacilityOptions(facilities)}
    />
  );
};

export default FacilitySelector;
